import { useRef, useEffect, useCallback, useState } from 'react';

export const useTimer = (callback, delay) => {
  const intervalRef = useRef(null);
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const startTimer = useCallback(() => {
    const tick = () => savedCallback.current();

    intervalRef.current = window.setInterval(tick, delay);
  }, [delay]);

  useEffect(() => {
    startTimer();
    return () => window.clearInterval(intervalRef.current);
  }, [startTimer]);

  return { intervalRef, startTimer };
};

export const useTimerProgress = expiry => {
  const [progress, setProgress] = useState(0);

  const { intervalRef, startTimer } = useTimer(() => {
    setProgress(progress => progress + 1);
  }, 1000);

  useEffect(() => {
    if (progress >= expiry) {
      clearInterval(intervalRef.current);
      setProgress(expiry);
      return;
    }
  }, [intervalRef, progress, expiry]);

  const reset = () => {
    setProgress(0);
    startTimer();
  };

  return {
    progress,
    reset,
  };
};
